var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClient15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208.132,
    height: 40.057,
    viewBox: "0 0 208.132 40.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_344",
    "data-name": "Rectangle 344",
    width: 208.132,
    height: 40.057,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo15",
    transform: "translate(50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(-50 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_708",
    "data-name": "Path 708",
    d: "M.046,32.3H14.912c10.4,0,20.8.022,31.206-.027a12.122,12.122,0,0,0,3.824-.642A3.454,3.454,0,0,0,52.346,28a3.407,3.407,0,0,0-2.5-3.423,13.6,13.6,0,0,0-3.995-.592Q23.977,23.92,2.1,23.954H.008V16.345H1.75q22.189,0,44.378-.019a12.241,12.241,0,0,0,3.678-.555,3.537,3.537,0,0,0,2.537-3.419,3.417,3.417,0,0,0-2.253-3.59,9.8,9.8,0,0,0-3.473-.7c-15-.042-30-.024-45-.02H0V.314H1.654Q24.627.311,47.6.3A14.238,14.238,0,0,1,56.719,3.52a10.781,10.781,0,0,1,1.5,15.819c-.169.2-.334.4-.569.677a11.536,11.536,0,0,1,3.392,7.85c.076,5.068-3.2,9.442-8.615,11.259a15.376,15.376,0,0,1-4.75.842c-15.472.053-30.944.021-46.416.009-.363,0-.725-.042-1.22-.073Z",
    transform: "translate(0 -0.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_709",
    "data-name": "Path 709",
    d: "M468.4,7.765V.088C468.972.057,469.521,0,470.069,0c12.437.047,24.876-.042,37.309.207,7.644.153,14.365,2.746,18.912,9.332a18.759,18.759,0,0,1-6.211,26.773,27.082,27.082,0,0,1-13.473,3.568q-18.107.094-36.214.174c-.673,0-1.347,0-2.132,0V32.4c.548,0,1.1,0,1.649,0q18.34-.128,36.681-.261a16.735,16.735,0,0,0,8.786-2.484,10.718,10.718,0,0,0,5.4-9.963,10.686,10.686,0,0,0-5.85-9.541A17.964,17.964,0,0,0,506.2,7.973q-18.108-.068-36.215-.139c-.463,0-.927-.039-1.582-.069",
    transform: "translate(-321.389 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_710",
    "data-name": "Path 710",
    d: "M321.379,17.529H331.2c4.024,0,8.049.015,12.073-.011a17.61,17.61,0,0,0,2.8-.244,3.219,3.219,0,0,0,3.054-3.062c.226-2.227.213-4.48.248-6.723.037-2.344.008-4.689.008-7.177h8.78c0,2.04.026,4.062-.006,6.083-.061,3.915.049,7.848-.291,11.74-.382,4.38-2.687,6.464-7.108,6.929-1.866.2-3.751.261-5.629.278-4.382.039-8.764.012-13.337.012V40.072H321.379Z",
    transform: "translate(-220.578 -0.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_711",
    "data-name": "Path 711",
    d: "M250.884,17.876v7.5c-.122.092-.2.206-.282.2-6.264-.06-12.537.049-18.79-.257-4.338-.212-6.752-2.5-6.98-6.817-.311-5.878-.078-11.784-.078-17.8h8.7V2.147c0,3.449-.019,6.9.006,10.347.03,4.077,1.314,5.363,5.348,5.379,3.968.016,7.936,0,12.078,0",
    transform: "translate(-154.202 -0.487)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient15);
export default __webpack_public_path__ + "static/media/client15.97a0213ab6aaaf5c53599df2816d8d32.svg";
export { ForwardRef as ReactComponent };